import { render, staticRenderFns } from "./ServiceTypeAdd.vue?vue&type=template&id=465aacad&"
import script from "./ServiceTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports